module.exports = __webpack_public_path__ + "img/periodontia.82eb8374.png";